<template>

    <form autocomplete="off" v-on:submit.prevent="saveData" class="trax-form">

        <trax-ui-checkbox :text="lang.polaris.dashboard.easa" col="md-4"
            label="Type"
            v-model="form.meta.easa"
        >
        </trax-ui-checkbox>

        <trax-ui-datetime :placeholder="lang.polaris.training.start_date" col="md-4"
            required="1"
            v-model="form.meta.start_date"
            :error="errors['meta.start_date']" type="date"
        >
        </trax-ui-datetime>

        <trax-ui-datetime :placeholder="lang.polaris.training.end_date" col="md-4"
            required="1"
            v-model="form.meta.end_date"
            :error="errors['meta.end_date']" type="date"
        >
        </trax-ui-datetime>

        <trax-ui-select :placeholder="lang.polaris.dashboard.location" col="md-4"
            :options="locations_select" grouped="1"
            required="1"
            v-model="form.meta.entity_id"
            :error="errors['meta.entity_id']"
        >
        </trax-ui-select>

        <trax-ui-select :placeholder="lang.polaris.dashboard.signatory" col="md-4"
            :options="signatories_select"
            required="1"
            v-model="form.meta.signatory_uuid"
            :error="errors['meta.signatory_uuid']"
        >
        </trax-ui-select>

        <!-- Options belonging to the caller, submitted with the settings. -->
        <slot name="options"></slot>

        <div class="trax-form-actions text-right">
            <button type="button" class="btn btn-default btn-link" data-dismiss="modal"> {{ lang.polaris.form.cancel }} </button>
            <button type="submit" class="btn btn-primary btn-round">{{ submitLabel ? submitLabel : 'OK' }}</button>
        </div>
    </form>

</template>

<script>
    export default {

        props: {
            id: null,
            toastrId: null,
            bus: null,
            learner: null,
            registration: null,

            // The same settings are recorded before generating the certificate alone, or before
            // queuing the full generation.
            submitLabel: null,
        },
    
        data: function() {
            return {
                lang: lang,
                form: {
                    type: 'certificate',
                    version: 0,
                    scheduled: 0,
                    registration_id: this.registration.id,
                    user_id: this.learner.id,
                    meta: {
                        easa: true,
                        start_date: data.start_date ? data.start_date : moment().format('YYYY-MM-DD'),
                        end_date: data.end_date ? data.end_date : moment().format('YYYY-MM-DD'),
                        entity_id: Object.values(data.locations_select)[0][0].value,
                        signatory_uuid: data.signatories_select[0].value,
                    }
                },
                errors: {meta: {}},
                locations_select: data.locations_select,
                signatories_select: data.signatories_select,
                endpoint: app_url+'polaris/api/front/export/learners/'+this.learner.id+'/registrations/'+this.registration.id+'/export/certificate',
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(this.id+'-data', function(data) {
                that.form = data
            });
        },
 
        methods: {
   
            saveData() {
                this.errors = {}
                var that = this;
                axios.post(this.endpoint, this.form)
                    .then(function (response) {
                        that.bus.$emit(that.id+'-close');
                        that.bus.$emit(that.id+'-updated', {data: that.form, response: response});
                    })
                    .catch(function (error) {
                        that.processErrors(error.response.data);
                    });
            },

            processErrors(data) {
                if (typeof data == 'string') {
                    if (this.toastrId) this.bus.$emit(this.toastrId+'-error', data);
                    return;
                }
                if (data.message && !data.errors) {
                    if (this.toastrId) this.bus.$emit(this.toastrId+'-error', data);
                    return;
                }
                var errors = data.errors;
                for (var name in errors) {
                    var error = errors[name];
                    if (error instanceof Array) errors[name] = error[0];
                }
                this.errors = errors;
            }
        }
   }
</script>
